import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { LoginService } from '../../api/login/login.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { Admin } from './../../modal/admin';
declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'cat-loginpage',
    templateUrl: './login-alpha.html'
})
export class PagesLoginAlpha implements OnInit {
    admin: Admin;
    username: String;
    mobileno: String;
    emailId: String;
    password: String;
    message: String;
    logintype = "superadmin"
    ngOnInit() {
        this.message = "";
    }
    constructor(private authService: LoginService,
        private router: Router) {
    }
    iLogin() {
        var atpos = this.username.includes("@");
        var count = (this.username.match(/@/g) || []).length;
        var user = {}
        if (atpos == true && count == 1) {
            this.emailId = this.username;
            this.mobileno = '';
            user = {
                email: this.emailId,
                password: this.password,
                logintype: this.logintype
            }
            this.login(user)
        } else {
            this.mobileno = this.username;
            this.emailId = '';
            user = {
                mobileno: this.mobileno,
                password: this.password,
                logintype: this.logintype
            }
            this.login(user)
        }
    }
    login(user) {
        this.authService.loginUser(user).
            then(admin => {
                if (admin.status == true) {
                    this.authService.storeUserData(admin.data, admin.role, admin.joincode);
                    if (admin.role == 'BLOGGER') {
                        this.router.navigate(['../blogpost']);
                    }
                    else 
                    {
                        localStorage.setItem('pageloadagain',"true");
                        this.router.navigate(['/dashboards']);
                    }
                    this.message = admin.message
                    $.notify({
                        message: this.message
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        }
                    });
                } else {
                    this.message = admin.message
                    $.notify({
                        message: this.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        }
                    });
                    this.password = '';
                    this.emailId = '';
                    this.mobileno = '';
                    this.username = '';
                }
            })
    }
    onCategoryChange() {
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/pages/login-alpha.page.ts